export default __webpack_public_path__ + "static/inapp-b1fb24d2a5e34b65c4c432c4cfb8a805.png";